const FETCHING_INVOICE_LIST = "@invoices/fetchingInvoiceList";
const FETCHING_INVOICE_LIST_ERROR = "@invoices/fetchingInvoiceListError";
const FETCHING_INVOICE_LIST_SUCCESS = "@invoices/fetchingInvoiceListSuccess";

const DOWNLOAD_INVOICE_LIST = "@invoices/downloadInvoiceList";
const DOWNLOAD_INVOICE_LIST_ERROR = "@invoices/downloadInvoiceListError";
const DOWNLOAD_INVOICE_LIST_SUCCESS = "@invoices/downloadInvoiceListSuccess";

const SET_ITEMS_COUNT_PER_PAGE = "@invoices/setItemsCountPerPage";
const SET_PAGE = "@invoices/setPage";
const SET_ORDER = "@invoices/setOrder";
const SET_FILTERS = "@invoices/setFilters";
const SELECT_INVOICE = "@invoices/selectInvoice";
const APPLY_METADATA = "@invoices/applyMetadata";
const RESET_STATE = "@invoices/resetState";

export {
  FETCHING_INVOICE_LIST,
  FETCHING_INVOICE_LIST_ERROR,
  FETCHING_INVOICE_LIST_SUCCESS,
  DOWNLOAD_INVOICE_LIST,
  DOWNLOAD_INVOICE_LIST_SUCCESS,
  DOWNLOAD_INVOICE_LIST_ERROR,
  SET_ITEMS_COUNT_PER_PAGE,
  SET_PAGE,
  SET_ORDER,
  SET_FILTERS,
  SELECT_INVOICE,
  APPLY_METADATA,
  RESET_STATE
};
